
/* global number, Intl */

export var StringUtil = {
	
	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},
	
	constantToWord(string) {
		var stringUtil = this;
		if (string) {
			var words = string.split('_');
			var newString = [];
			words.forEach(function(word) {			
				newString.push(stringUtil.capitalizeFirstLetter(word.toLowerCase()));				
			});
			return newString.join(' ');
		}
		return string;
	},
	
	camelcaseToWord(string) {
		if (string) {
			return this.capitalizeFirstLetter(string.replace(/([a-z0-9])([A-Z])/g, '$1 $2'));		
		} 
		return string;
	},
	
	currencyFormat(amount) {
		return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
	},
	
	newLineToHTML(input) {
		if (input) {
			input = input.replaceAll('\n', '<br>');
		}
		return input;
	},
	
	blankIfNull(input) {
		if (input) {
			return input;
		} else {
			return '';
		}
	}
};
